import React, { useMemo, useState, useEffect } from 'react';
import apiClient from '../api/client';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';

export default function STMfgs() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const columns = useMemo(
        () => [
            {
                accessorKey: 'mfg',
                header: 'Manufacturer',
                enableEditing: true,
                size: 250,
            },
            {
                accessorKey: 'prefix',
                header: 'MFG Prefix',
                size: 150,
            },
        ],
        []
    );
        
    const getSTMfgs = async () => {
        try {
            const res = await apiClient.get('/stmfgs');
            setData(res.data || []);
        } catch (error) {
            console.error('Error fetching ST MFGs:', error);
            setData([]);
        } finally {
            setLoading(false);
        }
    };

    const createSTMfg = async (newData) => {
        if (!newData?.mfg || !newData?.prefix) {
            console.error("Error - Invalid Name or Prefix");
            return false;
        }

        try {
            const url = "/stmfgs/";
            const body = { mfg: newData.mfg, prefix: newData.prefix };
            await apiClient.put(url, body);
            getSTMfgs();
            return true;
        } catch (error) {
            console.error('Error creating ST MFG:', error);
            return false;
        }
    };

    const handleCreateMfg = async ({ values, table }) => {
        // keep the row open on failure so the user doesn't lose their input
        if (await createSTMfg(values)) {
            table.setCreatingRow(null);
        }
    };

    const table = useMaterialReactTable({
        columns,
        data,
        muiPaginationProps: {
            rowsPerPageOptions: [15, 30, 50],
            showFirstButton: true,
            showLastButton: true,
        },
        getRowId: (row) => row.id,
        createDisplayMode: 'row',
        editDisplayMode: 'row',
        enableEditing: true,
        initialState: { pagination: { pageSize: 15, pageIndex: 0 } },
        state: { isLoading: loading },
        renderEmptyRowsFallback: () => (
            <Box sx={{ p: 5, textAlign: 'center' }}>
                <Typography variant="body1" color="text.secondary">
                    No Stevens Manufacturers found.
                </Typography>
            </Box>
        ),
        muiTablePaperProps: {
            elevation: 0,
            sx: {
                bgcolor: 'background.paper',
                border: 1,
                borderColor: 'divider',
                borderRadius: 2,
                boxShadow: 'none',
            },
        },
        renderTopToolbarCustomActions: ({ table }) => (
            <Button
                variant="contained"
                color="primary"
                startIcon={<AddIcon />}
                onClick={() => {
                    table.setCreatingRow(true);
                }}
                sx={{ ml: 1 }}
            >
                Create New MFG
            </Button>
        ),
        onCreatingRowSave: handleCreateMfg,
    });

    useEffect(() => {
        getSTMfgs();
    }, []);

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ mb: 3 }}>
                <Typography variant="h4" sx={{ fontWeight: 700, mb: 0.5 }}>
                    Stevens Manufacturers
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    Manage Stevens manufacturer prefixes and configuration rules
                </Typography>
            </Box>

            <MaterialReactTable table={table} />
        </Box>
    );
}